export const endpoint = process.env.REACT_APP_API_ENDPOINT;
export const MERCURE_URL = process.env.REACT_APP_MERCURE_ENDPOINT;
